import { render, staticRenderFns } from "./ToolsCategoryProcessors.vue?vue&type=template&id=b4051804"
import script from "./ToolsCategoryProcessors.vue?vue&type=script&lang=js"
export * from "./ToolsCategoryProcessors.vue?vue&type=script&lang=js"
import style0 from "./ToolsCategoryProcessors.vue?vue&type=style&index=0&id=b4051804&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports